module.exports = __webpack_public_path__ + "static/kaffe1-7feef0e76cdeda19c9a788a38ca7a14e.jpg";